import axiosInstance from './axiosInstance';

/**
 * AI 캐스팅 검색 사용 가능 여부 (로그인 필요)
 *
 * 제작사이고, 기능이 켜져 있고, 허용 목록에 해당할 때만 true.
 * 허용 목록 같은 다른 정보는 서버가 주지 않는다. 프론트는 이 값이 true일 때만 입구를 보여준다.
 * @returns {boolean}
 */
export const getAiSearchAvailability = async () => {
  const res = await axiosInstance.get('/api/talent/ai-search/availability');
  return Boolean(res.data?.available);
};

/**
 * AI 캐스팅 검색 (제작사 전용)
 *
 * 공고 문장을 그대로 보내면 조건(성별·나이·키·스킬)을 해석해 엄격하게 거른 뒤,
 * 외모·인상 설명으로 매긴 순서대로 배우 목록을 준다. 점수·일치율은 응답에 없다.
 *
 * @param {{ query: string, limit?: number }} params
 * @returns {{ status: 'OK'|'NO_MATCH', message: string|null,
 *             conditions: { gender, ageMin, ageMax, heightMin, heightMax, skillsRequired, skillsPreferred },
 *             appearance: string|null,
 *             talents: Array }}
 */
export const searchTalentsByAi = async ({ query, limit = 20 }) => {
  const res = await axiosInstance.post('/api/talent/ai-search', { query, limit });
  return res.data;
};
